module.exports = __webpack_public_path__ + "static/img/layout.20bdf07e.jpeg";